module.exports = __webpack_public_path__ + "static/img/twjd-sd3.29fe3c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sd3.png
// module id = 830
// module chunks = 0